
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'Logo',
  computed: {
    ...mapGetters([
      'global'
    ]),
    accessibleLogoLabel(): string {
      if (this.global.logoName) {
        return this.$t('message.accessibility.brand_logo_named', {
          brand: this.global.logoName
        }) as string;
      }

      return this.$t('message.accessibility.brand_logo') as string;
    }
  }
});
